import { Button as MuiButton, useTheme } from '@mui/material'
import { styled } from '@mui/material/styles'

import SortButton from './SortButton'

import { Loader } from 'packages/eid-ui'
import FiltersButton from './FiltersButton'

const styles = {
    small: {
        padding: '3.25px 20px',
        minHeight: '35px',
    },
    medium: {
        padding: '5.25px 15px',
        minHeight: '39px',
    },
    large: {
        padding: '9.25px 30px',
        minHeight: '47px',
    },
}

const StyledButton = styled(MuiButton)(
    ({ size, variantStyles, customStyle, disabledStyles, disabled }) => ({
        textTransform: 'capitalize',
        fontSize: '16px',
        border: '1px solid transparent',
        borderRadius: '5px',
        ...variantStyles,
        ...customStyle,
        ...(disabled && disabledStyles),
        '& .MuiButton-startIcon': {
            marginRight: size === 'large' ? '14px' : '10px',
        },
    }),
)

const MobileButtons = (props) => {
    const {
        size,
        children,
        style,
        disabledStyles,
        loading,
        loaderColor,
        startIcon,
        endIcon,
        onClick,
        ...rest
    } = props
    const variantStyles = styles[size]
    const theme = useTheme()

    return (
        <StyledButton
            startIcon={!loading && startIcon}
            endIcon={!loading && endIcon}
            size={size}
            variantStyles={variantStyles}
            customStyle={style}
            disabledStyles={disabledStyles}
            onClick={!loading ? onClick : undefined}
            {...rest}
        >
            {!loading ? (
                children
            ) : (
                <Loader
                    color={
                        loaderColor
                            ? loaderColor
                            : theme?.palette?.common?.white
                    }
                    size={0.6}
                />
            )}
        </StyledButton>
    )
}

MobileButtons.Sort = SortButton
MobileButtons.Filter = FiltersButton

export default MobileButtons
